export default __webpack_public_path__ + "static/media/cconteinterview.632675ef.png";